export const NOT_FOUND_TEXT = {
  LOGO_ALT: "CherryClipz logo",
  BRAND_NAME: "CherryClipz",
  HEADING: "Oops",
  SUBHEADING: "Page Not Found...",
  DESCRIPTION_LINE_1: "It's not the end of the world as we know it,",
  DESCRIPTION_LINE_2: "just a page not found.",
  GO_HOME_BUTTON: "Go Home",
} as const;
